import { Arrow, Content } from '@radix-ui/react-tooltip'
import * as React from 'react'

import { styled } from '~/styled'

const StyledContent = styled(Content, {
  base: [
    'bg-grey-900',
    'rounded-sm',
    'shadow-sm',
    'text-white',
    'font-body',
    'text-sm',
    'leading-normal',
    'whitespace-normal',
    'px-3',
    'py-2',
    'z-10',
    'will-change-transform',
    'will-change-[opacity]',
    '[--slide-opacity-out:0]',
    'data-[side=top]:[--slide-direction-out-y:-4px]',
    'data-[side=right]:[--slide-direction-out-x:4px]',
    'data-[side=bottom]:[--slide-direction-out-y:4px]',
    'data-[side=left]:[--slide-direction-out-x:-4px]',
    'motion-safe:data-[state=delayed-open]:animate-slide-direction-in',
    'motion-safe:data-[state=closed]:animate-slide-direction-out'
  ],
  variants: {
    size: {
      sm: ['max-w-25'],
      md: ['max-w-[250px]'],
      lg: ['max-w-100']
    }
  }
})

const StyledArrow = styled(Arrow, {
  base: [
    'fill-grey-900',
    'in-data-[align=end]:mr-2',
    'in-data-[align=start]:ml-2'
  ]
})

type TooltipContentProps = React.ComponentProps<typeof StyledContent> &
  React.ComponentProps<typeof Content>

export const TooltipContent = ({
  children,
  side = 'top',
  sideOffset = 4,
  size = 'md',
  ...remainingProps
}: TooltipContentProps) => (
  <StyledContent
    side={side}
    sideOffset={sideOffset}
    size={size}
    {...remainingProps}
  >
    {children}
    <StyledArrow />
  </StyledContent>
)
